import { styled } from '@mui/material';
export const PickerContainer = styled('div')({
    width: 250,
    '& .react-colorful': {
        height: 300,
        width: '100%',
    },
    '& .react-colorful__pointer': {
        borderWidth: 4,
        height: 16,
        width: 16,
    },
    '& .react-colorful__interactive:focus .react-colorful__pointer': {
        transform: 'translate(-50%,-50%)',
    },
    '& .react-colorful__saturation': {
        borderRadius: 0,
        height: 250,
    },
    '& .react-colorful__hue': {
        borderRadius: 9,
        margin: 16,
        minHeight: 18,
        height: 18,
        '& .react-colorful__interactive': {
            minHeight: 18,
            height: 18,
        },
    },
});
